module.exports = __webpack_public_path__ + "img/logo-ticketshop-ve.2731326c.png";